export default __webpack_public_path__ + "static/media/eye - active_v1.3ac71e6c.svg";